export default {
  AnyApprover: 'anyApproverForRequisitions',
  FirstApprover: 'firstApproverForRequisitions',
}
